<template>
  <div class="IrDeviceSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="IrDeviceSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="IrDeviceSettings-main lxn-pos-rel">
      <div class="IrDeviceSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddIrDevice_title1}}
          </template>
          <template v-slot:body>
            <div class="IrDeviceSettings-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="DeviceName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddIrDevice_namePlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.IrDeviceSettings_title3}}
          </template>
          <template v-slot:body>
            <div class="IrDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="showRemote" bgColor="#1EA5DE" iconRight="remoteController" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.IrDeviceSettings_showRemote}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddIrDevice_title2}}
          </template>
          <template v-slot:body>
            <div class="IrDeviceSettings-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text2}}
            </div>
            <div class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{deviceTypeText}}
            </div>
            <div class="IrDeviceSettings-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text3}}
            </div>
            <div class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{brandText}}
            </div>
            <div class="IrDeviceSettings-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text4}}
            </div>
            <div class="lxn-w100 lxn-text lxn-text-en lxn-text-center">
              {{modelText}}
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="IrDeviceSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddIrDevice_button}}
        </CustomButton>
      </div>
      <div class="IrDeviceSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="deleteOutput" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.IrDeviceSettings_button2}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'IrDeviceSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
  },
  data: function () {
    return {
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      DeviceName: '',
      input1State: '',
      targetDeviceType: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID).outputs[this.$route.params.outputIndex].settings.deviceType,
      targetBrand: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID).outputs[this.$route.params.outputIndex].settings.brand,
      targetModel: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID).outputs[this.$route.params.outputIndex].settings.model,
    }
  },
  mounted: function () {
    this.DeviceName = this.output.name;
  },
  watch: {
    targetDeviceType: function (){
      this.targetBrand = 0;
      this.targetModel = 0;
    },
    targetBrand: function (){
      this.targetModel = 0;
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    output: function () {
      return this.node.outputs[this.$route.params.outputIndex];
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    deviceTypeText: function () {
      return this.$store.getters.language.texts[NODE7.devices[this.targetDeviceType].name];
    },
    brandText: function () {
      return NODE7.devices[this.targetDeviceType].brands[this.targetBrand].name;
    },
    modelText: function () {
      return NODE7.devices[this.targetDeviceType].brands[this.targetBrand].devices[this.targetModel].name;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    showRemote: function () {
      this.$router.push('/showIrRemote/' + this.node.uuid + '/' + this.$route.params.outputIndex);
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.DeviceName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.IrDeviceSettings_alert1);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('editDeviceOutput', {
          nodeIndex: this.node.index,
          outputIndex: this.$route.params.outputIndex,
          output: {
            name: this.DeviceName,
            settings: {
              deviceType: this.targetDeviceType,
              brand: this.targetBrand,
              model: this.targetModel,
            }
          }
        });
        this.$store.commit('saveState');
        this.$router.push('/home/devices/');
        this.$store.commit('setAppBusy', false);
      }
    },
    deleteOutput: function () {
      this.$router.push('/deleteIrDevice/' + this.node.uuid + '/' + this.$route.params.outputIndex);
    },
  }
}
</script>

<style>
  .IrDeviceSettings-topCurve-wrapper {
    height: 200px;
  }
  .IrDeviceSettings-main {
    z-index: 2;
  }
  .IrDeviceSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .IrDeviceSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .IrDeviceSettings-wrapper-colors {
    height: 50px;
  }
  .IrDeviceSettings-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .IrDeviceSettings-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .IrDeviceSettings-color.active .IrDeviceSettings-selectedColor {
    opacity: 1;
  }
  .IrDeviceSettings-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .IrDeviceSettings-wrapper-name-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .IrDeviceSettings-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .IrDeviceSettings-wrapper-fieldText {
    margin-top: 14px;
    line-height: 20px;
    color: #52626C;
  }
  .IrDeviceSettings-wrapper-button {
    width: calc(100% - 36px);
    margin-top: 15px;
    margin-bottom: 14px;
  }
  .IrDeviceSettings-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .IrDeviceSettings-wrapper-commands:first-child {
    margin-top: 0;
  }
  .IrDeviceSettings-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .IrDeviceSettings-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
